import type { UserRole } from '@/types';

/** Profils qui voient le tableau de bord formateur (CreatorDashboard) et le menu « pilotage / création ». */
export function isTrainerDashboardTourEligibleRole(role: string | undefined | null): boolean {
  const r = (role ?? '') as UserRole;
  return r === 'teacher' || r === 'resp_formation';
}
